import React, { useContext } from "react";
import { ErrorBoundary, Page, hasActiveFilters } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { filterUpdated, initFilter, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../store/secretsSlice";
import { ReportContext } from "../context";
import { useReportDispatch, useReportSelector } from "../hooks";
import { useGetSecretsQuery } from "../services/secrets.api";
import { useGetReportSummaryQuery } from "../services/shared.api";
import SecretsFilters from "./SecretsFilters/SecretsFilters";
import SecretsTable from "./SecretsTable/SecretsTable";
const SecretsTabContent = () => {
    var _a, _b, _c;
    const dispatch = useReportDispatch();
    const { reportId, diffId } = useContext(ReportContext);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { data: secretsData, isLoading, isFetching, isError, error, } = useGetSecretsQuery({
        ui_id: reportId,
        filter,
        sort,
        pagination,
    });
    const secretsCounters = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.secrets;
    const triagedSecrets = secretsCounters &&
        secretsCounters.triaged > 0 &&
        `${secretsCounters.triaged.toLocaleString()} Triaged`;
    const secretsCount = secretsCounters &&
        `${secretsCounters.exposed.toLocaleString()} Exposed Secrets`;
    return (React.createElement(ErrorBoundary, { key: "secrets" },
        React.createElement(Page.Root, null,
            React.createElement(Page.Header, { title: "Secrets", details: [secretsCount, triagedSecrets] }),
            React.createElement(Page.Filters, { found: {
                    id: "secrets-clear-all-filters",
                    count: (_a = secretsData === null || secretsData === void 0 ? void 0 : secretsData.match_count) !== null && _a !== void 0 ? _a : 0,
                    initialFilters: initFilter,
                    activeFilters: filter,
                    onClear: () => dispatch(filterUpdated(initFilter)),
                } },
                React.createElement(SecretsFilters, { filter: filter, onFilterChange: (filter) => dispatch(filterUpdated(filter)) })),
            React.createElement(Page.Body, null,
                React.createElement(SecretsTable, { secrets: (_b = secretsData === null || secretsData === void 0 ? void 0 : secretsData.secrets) !== null && _b !== void 0 ? _b : [], matchCount: (_c = secretsData === null || secretsData === void 0 ? void 0 : secretsData.match_count) !== null && _c !== void 0 ? _c : 0, endpointFilter: filter.endpoint, filters: {
                        active: hasActiveFilters(initFilter, filter),
                        onReset: () => dispatch(filterUpdated(initFilter)),
                    }, status: getQueryStatus({
                        isLoading,
                        isFetching,
                        isError,
                        error,
                        data: secretsData,
                    }), pagination: pagination, handlePaginationChange: (pagination) => dispatch(paginationUpdated(pagination)), sort: sort, handleSortChange: (sort) => dispatch(sortUpdated(sort)) })))));
};
export default SecretsTabContent;
//# sourceMappingURL=SecretsTabContent.js.map